window.actualizarTableroInyeccionPeriodo = null;

if (window.location.pathname === "/inyeccion/periodo") {

    const requestOptions = {
        method: "GET",
        credentials: "include", 
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };
    
    const conInfoBox = document.querySelector("#conInfoBox");
    var params = new URLSearchParams(window.location.search);
    var mes = params.get("mes");
    var año = params.get("año");
    
    window.actualizarTableroInyeccionPeriodo = (mes, año) => {

        const url = `/api/inyeccion/tableroPeriodo?mes=${mes}&año=${año}`;

        function formatearNumero(numero) {
            if (numero === null || numero === undefined || isNaN(numero)) return 0;
            return Number(numero).toLocaleString('en-US');
        }
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                const data = result.result[0];

                let htmlTablero = `
                    <div class="contCant">
                        <div class="contCantUnidades">
                            <div class="infoBox">
                                <h3>🏭 Und. Producidas:</h3>
                                <p>${formatearNumero(data.undTotal)}</p>
                            </div>
                            <div class="infoBox">
                                <h3>✅ Und. Buenas:</h3>
                                <p>${formatearNumero(data.undBueno)}</p>
                            </div>
                            <div class="infoBox">
                                <h3>⚠️ Und. No conformes:</h3>
                                <p>${formatearNumero(data.undMalo)}</p>
                            </div>
                        </div>
                        <div class="contCantPeso">
                            <div class="infoBox">
                                <h3>⚖️ Peso Producido:</h3>
                                <p>${formatearNumero(data.pesoTotal)} t</p>
                            </div>
                            <div class="infoBox">
                                <h3>🟢 Peso Bueno:</h3>
                                <p>${formatearNumero(data.pesoBueno)} t</p>
                            </div>
                            <div class="infoBox">
                                <h3>🔴 Peso No conforme:</h3>
                                <p>${formatearNumero(data.pesoMalo)} kg</p>
                            </div>
                        </div>
                    </div>
                    <div class="contCantPorcentajes">
                        <div class="infoBox">
                            <h3>🏅 % 1A:</h3>
                            <p>${formatearNumero(data.porcBueno)}%</p>
                        </div>
                        <div class="infoBox">
                            <h3>🚫 % No conforme:</h3>
                            <p>${formatearNumero(data.porcMalo)}%</p>
                        </div>
                    </div>
                    <div class="contProductividad">
                        <div class="infoBox">
                            <h3>⏱️ Tiempo muerto:</h3>
                            <p>${formatearNumero(data.totalMinutosMuertos)}'</p>
                        </div>
                        <div class="infoBox">
                            <h3>📊 Prom. Und./Dia:</h3>
                            <p>${formatearNumero(data.promUndDia)}</p>
                        </div>
                    </div>
                    `;

                conInfoBox.innerHTML = htmlTablero;
                conInfoBox.classList.remove('cargado');
                void conInfoBox.offsetWidth;
                conInfoBox.classList.add('cargado');

            })
            .catch(err => {
                if (err.name === 'AbortError') return;
                console.error("Error tablero inyección:", err);
                return;
            });
    };

    // Cargar la tabla por primera vez
    window.actualizarTableroInyeccionPeriodo(mes, año);
    // Recarga cada 60 segundos
    setInterval(() => {
        actualizarTableroInyeccionPeriodo(mes, año);
    }, 120000);

};